import debounce from 'lodash/debounce';
import { TRANSLATIONS } from '../../app/config/config';

const parseAddress = (address) => {
  const items = address.address_components;
  const addressInfo = {};

  items.forEach((component) =>
    component.types.forEach((type) => {
      let name = component.short_name;

      if (name.indexOf('województwo') >= -1) {
        name = name.replace('województwo ', '');
      }

      addressInfo[type] = name;
    }),
  );

  return addressInfo;
};

const withDebounce = debounce((func) => func(), 1000);

const getLabels = (items) => {
  const labels = items.map((id) => TRANSLATIONS[id]).join(';');
  const newLabels = `${labels}\r\n`;

  return newLabels;
};

const parseExcelData = (data) => {
  const startStr = getLabels(['lp', ...Object.keys(data[0])]);

  return data.reduce((str, item, index) => {
    const keys = Object.keys(item);
    let newStr = `${index + 1};`;

    keys.forEach((key) => {
      newStr += `${item[key] === null ? '' : item[key]};`;
    });

    newStr += '\r\n';

    return str + newStr;
  }, startStr);
};

export { parseAddress, withDebounce, parseExcelData };
